import React from 'react'
import clsx from 'clsx'
import Chip from '@material-ui/core/Chip'
import SvgIcon from '@material-ui/core/SvgIcon'
import useStyles from './styles'

const Filter = ({ selected, setSelected, icon, label }) => {
  const handleClick = () => {
    setSelected(!selected)
  }

  const classes = useStyles()
  return (
    <Chip
      variant="outlined"
      size="small"
      icon={<SvgIcon className={classes.icon} component={icon} />}
      label={label}
      onClick={handleClick}
      className={clsx(classes.root, selected && classes.selected)}
    />
  )
}

export default Filter
